module.exports = "body body {\n  min-height: 500px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/community-user/community-user.component.css
// module id = ./src/app/Screens/community-user/community-user.component.css
// module chunks = main